import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { MonitoringService } from '../monitoring/monitoring.service';

@Injectable({
  providedIn: 'root',
})
export class EmployeeStatusesService {
  _ = require('lodash');
  moment = require('moment');
  private _isAddData: BehaviorSubject<boolean>;

  constructor(private http: HttpClient) {
    this._isAddData = <BehaviorSubject<boolean>>new BehaviorSubject(null);
  }

  get isAddData() {
    return this._isAddData.asObservable();
  }

  updateGetDataState(state: boolean) {
    this._isAddData.next(state);
  }

  getCurrentTime(params) {
    return this.http.get(`/admin/sectors/sector_time/`, { params: params });
  }

  getEmployers(params) {
    return this.http.get(`/admin/monitoring/users/`, { params: params });
  }

  getFilterStatuses(params) {
    // return this.http.get(`/admin/monitoring/users/count/`, {params: params});
    return this.http.get(`/admin/monitoring/users/brigades/`, {
      params: params,
    });
  }

  getEmployersStatuses(params) {
    return this.http.get(`/admin/monitoring/users/user_intervals/`, {
      params: params,
    });
  }

  getEmployeeCurrentStatuses() {
    return this.http.get(`/admin/schedule_worklog_statuses/`);
  }

  changeEmployeeStatus(data) {
    return this.http.post(`/admin/monitoring/users/`, data);
  }

  isToday(child, date) {
    const compareValue = this.moment(date, 'YYYY-MM-DD');
    const attrValue = this.moment(
      child.attributes.getNamedItem('data-content-date').nodeValue,
      'YYYY-MM-DD'
    );
    return this.moment(attrValue).isSame(compareValue, 'days');
  }

  /**
   * Сортировать сотрудников фт1 538559/19
   * Список сотрудников требуется сортировать: вверху показывать сотрудников, имеющих смену по графику в выбранный день
   * (в алфавитном порядке), ниже показывать сотрудников, не имеющих смену по графику в выбранный день (в алфавитном порядке).
   * *Внимание!* Метод создает копию массив и производит сортировку в ней, т.о. исходная коллекция не меняется.
   *
   * @method getEmployersSorted
   * @param employers {Array}
   * @param currentDay {Object}
   * @return {Array} отосортированный массив
   */
  getEmployersSorted(employers, currentDay) {
    currentDay = this.moment(currentDay);
    let res;
    let employersClone = this._.clone(employers);

    if (this._.isEmpty(employers)) {
      res = employersClone;
    } else {
      res = employersClone.sort((empA, empB) => {
        let comparedRes = 0;
        let isWorkTodayA, isWorkTodayB;
        let scheduleBeginA, scheduleEndA, scheduleBeginB, scheduleEndB;

        // если есть начало, то есть и конец
        if (this._.has(empA, 'working_shift[0].schedule.int_begin')) {
          scheduleBeginA = empA.working_shift[0].schedule.int_begin;
          scheduleEndA = empA.working_shift[0].schedule.int_end;
        }
        if (this._.has(empB, 'working_shift[0].schedule.int_begin')) {
          scheduleBeginB = empB.working_shift[0].schedule.int_begin;
          scheduleEndB = empB.working_shift[0].schedule.int_end;
        }
        isWorkTodayA = currentDay.isSame(scheduleBeginA, 'day') || currentDay.isSame(scheduleEndA, 'day');
        isWorkTodayB = currentDay.isSame(scheduleBeginB, 'day') || currentDay.isSame(scheduleEndB, 'day');

        if (isWorkTodayA > isWorkTodayB) {
          // если A попадает на сегодня, а B нет, то A показывать раньше
          comparedRes = -1;
        } else if (isWorkTodayA < isWorkTodayB) {
          // если B попадает на сегодня, а A нет, то B показывать раньше
          comparedRes = 1;
        } else {
          // если оба попадают на сегодня или не попадают, то сравнивать по именам
          comparedRes = empA.employee.full_name.localeCompare(empB.employee.full_name);
        }

        return comparedRes;
      });
    }
    return res;
  }

  getChangeStatusDataUnion(params) {
    const statuses = this.getEmployeeCurrentStatuses();
    const time = this.getCurrentTime(params);

    return forkJoin([statuses, time]);
  }

  getEmployeeDataUnion(params) {
    const filterParams = {
      int_begin: params.int_begin,
      int_end: params.int_end,
      sector_id: params.sector_id,
      groups: params.groups,
    };

    const employeers = this.getEmployers(params);
    const filterStatuses = this.getFilterStatuses(filterParams);

    return forkJoin([employeers, filterStatuses]);
  }
}
